module.exports = __webpack_public_path__ + "img/81.f8b976ce.webp";